import { Injectable } from "@angular/core";
import { LocalStorageKeys } from "src/app/core/constants/storage.keys";
import { TransactionTypeDto } from "src/openapi-gen/models";
import { TransactionPacket } from "../models/transaction-packet";

@Injectable({
  providedIn: "root",
})
export class TransactionRoutingService {

  private emptyPacket: TransactionPacket = {
    title: "",
    type: "",
    kiosk: false,
    billOfLading: false
  };

  transactionTypes: TransactionTypeDto[] = [];

  updatePacket(arg: TransactionPacket){
    sessionStorage.setItem(LocalStorageKeys.TransactionKey, JSON.stringify(arg));
  }

  getPacket(): TransactionPacket{
    let item = sessionStorage.getItem(LocalStorageKeys.TransactionKey);
    if(item === null){
      return this.emptyPacket;
    } else {
      return JSON.parse(item);
    }
  }
}